/**
 * Adds an agentSlug as a subdomain to a domain
 * @param domain - The original domain
 * @param agentSlug - The agentSlug
 *
 * @example
 * addAgentSlugSubdomainToDomain("https://tophouse.com", benamir)
 * // https://benamir.tophouse.com
 */
import extractSubdomain from '../extractSubdomain';

export default function addAgentSlugSubdomainToDomain(
  domain: string,
  agentSlug: string,
) {
  const url = new URL(domain);

  const existingSubdomain = extractSubdomain(domain);
  if (existingSubdomain) {
    throw new Error(
      `Cannot add subdomain ${agentSlug} to existing domain ${domain}. A subdomain already exists (${existingSubdomain})`,
    );
  }

  const domainStripLeadingWww = url.host.replace(/^www(\.?)/, '');

  url.host = `${agentSlug}.${domainStripLeadingWww}`;
  return url.toString();
}
